var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "foods_brands_config",
      attrs: {
        disabled: _vm.disabled,
        model: _vm.value.config,
        "hide-required-asterisk": "",
      },
    },
    [
      _c(
        "el-form-item",
        {
          attrs: {
            rules: [
              {
                max: 10,
                message: "标题长度最多10个字",
                trigger: "change",
              },
            ],
            prop: "name",
          },
        },
        [
          _c("div", { staticClass: "label" }, [_vm._v("组件标题")]),
          _c("el-input", {
            attrs: { placeholder: "输入10个字以内的标题", clearable: "" },
            model: {
              value: _vm.value.config.name,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "name", $$v)
              },
              expression: "value.config.name",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          attrs: {
            rules: [
              {
                max: 20,
                message: "说明长度最多20个字",
                trigger: "change",
              },
            ],
            prop: "description",
          },
        },
        [
          _c("div", { staticClass: "label" }, [_vm._v("组件说明（选填）")]),
          _c("el-input", {
            attrs: { placeholder: "输入20个字以内的说明", clearable: "" },
            model: {
              value: _vm.value.config.description,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "description", $$v)
              },
              expression: "value.config.description",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          attrs: {
            rules: [{ required: true, message: "菜单不可为空" }],
            prop: "category_id",
          },
        },
        [
          _c("div", { staticClass: "label" }, [_vm._v("选择菜单")]),
          _c(
            "el-select",
            {
              staticStyle: { width: "100%" },
              attrs: {
                placeholder: "请选择菜单",
                clearable: "",
                filterable: "",
              },
              on: { change: _vm.changeCategory },
              model: {
                value: _vm.value.config.category_id,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "category_id", $$v)
                },
                expression: "value.config.category_id",
              },
            },
            _vm._l(_vm.menuListFilter, function (menu) {
              return _c("el-option", {
                key: menu.id,
                attrs: {
                  label: menu.show_name,
                  value: menu.id,
                  disabled: menu.disabled,
                },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "label" }, [
        _vm._v(" 设置点餐品牌图及是否隐藏 "),
        _c("div", { staticClass: "tips" }, [
          _vm._v("隐藏后用户无法使用，拖动分类可调整排序"),
        ]),
      ]),
      _c(
        "draggable",
        {
          attrs: { animation: "500", "force-fallback": true },
          model: {
            value: _vm.value.config.value,
            callback: function ($$v) {
              _vm.$set(_vm.value.config, "value", $$v)
            },
            expression: "value.config.value",
          },
        },
        _vm._l(_vm.value.config.value, function (item, index) {
          return _c(
            "div",
            { key: item.id, class: ["box", !item.flag && "disabled"] },
            [
              _c(
                "div",
                { staticClass: "list" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "value." + index + ".flag",
                        rules: [
                          {
                            required: true,
                            validator: function (rule, value, callback) {
                              return _vm.checkFlag(rule, value, callback)
                            },
                          },
                        ],
                      },
                    },
                    [
                      _c("div", { staticClass: "label" }, [
                        _vm._v(" " + _vm._s(item.name) + " "),
                      ]),
                      _c("el-switch", {
                        attrs: {
                          "active-value": true,
                          "inactive-value": false,
                        },
                        model: {
                          value: item.flag,
                          callback: function ($$v) {
                            _vm.$set(item, "flag", $$v)
                          },
                          expression: "item.flag",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "brand_image",
                  attrs: {
                    prop: "value." + index + ".brand_image",
                    rules: [
                      {
                        required: item.flag,
                        message: "品牌图不可为空",
                        trigger: "change",
                      },
                    ],
                  },
                },
                [
                  _c("div", { staticClass: "upload-item-wrap" }, [
                    _c(
                      "div",
                      { staticClass: "left" },
                      [
                        _c("upload-file", {
                          ref: "uploadBanner",
                          refInFor: true,
                          attrs: {
                            "link-url": _vm.linkUrl,
                            tempurl: item.brand_image,
                            uploadInfo: _vm.uploadInfo,
                            disabled: !item.flag,
                          },
                          on: {
                            emitUploadFile: function (res) {
                              return _vm.emitUploadFile(res, item)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "right" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { disabled: !item.flag },
                            on: {
                              click: function ($event) {
                                return _vm.onUpload("uploadBanner", index)
                              },
                            },
                          },
                          [_vm._v(" 修改图片 ")]
                        ),
                        _vm.pictureList.length > 0
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectPicture(index)
                                  },
                                },
                              },
                              [_vm._v("选择图片")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ],
            1
          )
        }),
        0
      ),
      _c("div", { staticClass: "label" }, [
        _c(
          "div",
          { staticClass: "title" },
          [
            _vm._v(" 点餐组件占位图 "),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "site_image_open",
                  rules: [
                    {
                      required: true,
                      message: "请选择",
                      trigger: "change",
                    },
                  ],
                },
              },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.value.config.site_image_open,
                      callback: function ($$v) {
                        _vm.$set(_vm.value.config, "site_image_open", $$v)
                      },
                      expression: "value.config.site_image_open",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: 1 } }, [_vm._v("开启")]),
                    _c("el-radio", { attrs: { label: 0 } }, [_vm._v("关闭")]),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "tips" }, [
          _vm._v("上传占位图，图片会展示在组件最后一个品牌后面"),
        ]),
      ]),
      _vm.value.config.site_image_open === 1
        ? [
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "site_image",
                  rules: [
                    {
                      required: true,
                      message: "占位图不可为空",
                      trigger: "change",
                    },
                  ],
                },
              },
              [
                _c("div", { staticClass: "site_image" }, [
                  _c("div", { staticClass: "upload-item-wrap" }, [
                    _c(
                      "div",
                      { staticClass: "left" },
                      [
                        _c("upload-file", {
                          ref: "siteImage",
                          attrs: {
                            "link-url": _vm.linkUrl,
                            tempurl: _vm.value.config.site_image,
                            canDel: Boolean(_vm.value.config.site_image),
                            uploadInfo: _vm.uploadInfo,
                          },
                          on: {
                            onDelete: _vm.deleteImg,
                            emitUploadFile: function (url) {
                              return _vm.emitUploadFile(
                                url,
                                _vm.value.config,
                                "site_image"
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "right" },
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.onUpload("siteImage")
                              },
                            },
                          },
                          [_vm._v("上传图片")]
                        ),
                        _vm.pictureList.length > 0
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectPicture("site_image")
                                  },
                                },
                              },
                              [_vm._v("选择图片")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "is_jump_home",
                  rules: [
                    {
                      required: true,
                      message: "请选择",
                    },
                  ],
                },
              },
              [
                _c("span", { staticStyle: { "margin-right": "5px" } }, [
                  _vm._v("是否跳转菜单首页"),
                ]),
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.value.config.is_jump_home,
                      callback: function ($$v) {
                        _vm.$set(_vm.value.config, "is_jump_home", $$v)
                      },
                      expression: "value.config.is_jump_home",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                    _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _c(
        "el-form-item",
        {
          staticClass: "bg_color",
          attrs: {
            prop: "bg_color",
            rules: [{ required: true, message: "背景色不可为空" }],
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: { "font-weight": "400", color: "#303133" },
              attrs: { slot: "label" },
              slot: "label",
            },
            [_vm._v(" 组件楼层背景色 ")]
          ),
          _c("el-color-picker", {
            model: {
              value: _vm.value.config.bg_color,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "bg_color", $$v)
              },
              expression: "value.config.bg_color",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "margin_top",
          attrs: {
            prop: "margin_top",
            rules: [{ type: "number", message: "间距必须为数字值" }],
          },
        },
        [
          _c("div", [_vm._v(" 与上方组件的间距 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "z_index",
          attrs: {
            prop: "z_index",
            rules: [
              {
                required: true,
                pattern: /^(?:[1-9]|[1-9][0-9])$/,
                message: "请输入1-99之间的整数！",
              },
            ],
          },
        },
        [
          _c("div", [_vm._v(" 层级高度值 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
      _vm.showPictureLibrary
        ? _c("picture-library", {
            attrs: {
              configData: _vm.value,
              pictureList: _vm.pictureList,
              depot: _vm.depot,
            },
            on: {
              onClose: function ($event) {
                _vm.showPictureLibrary = false
              },
              onSubmit: _vm.onChangePic,
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }